import { useEffect, useState } from "react";
import { AlertCircle, KeyRound } from "lucide-react";
import { linkInfo, setPassword, setToken } from "../lib/api";

// Where the emailed link lands: choose your own password, then you are signed in.
export default function SetPassword({ token, onDone }) {
  const [info, setInfo] = useState(null);
  const [pw, setPw] = useState("");
  const [again, setAgain] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { linkInfo(token).then(setInfo).catch(e => setError(e?.response?.data?.detail || "This link is not valid.")); }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { setError("Choose a password of at least 8 characters"); return; }
    if (pw !== again) { setError("The two passwords are different"); return; }
    setBusy(true); setError("");
    try { const r = await setPassword(token, pw); setToken(r.token); window.history.replaceState({}, "", window.location.pathname); onDone(); }
    catch (err) { setError(err?.response?.data?.detail || "Could not save the password"); } finally { setBusy(false); }
  };
  return <div className="login-shell"><form className="modal login-card" onSubmit={submit} data-testid="set-password-form">
    <div className="modal-icon"><KeyRound size={20} /></div>
    <h2>{info?.kind === "reset" ? "Choose a new password" : "Welcome. Choose your password"}</h2>
    {info && <p>Signing in as <b>{info.email}</b>. Pick a password only you know. You will use it every time you sign in.</p>}
    {info && <>
      <label>New password (at least 8 characters)<input type="password" autoComplete="new-password" value={pw} onChange={e => setPw(e.target.value)} autoFocus data-testid="new-password" /></label>
      <label>Type it again<input type="password" autoComplete="new-password" value={again} onChange={e => setAgain(e.target.value)} data-testid="new-password-again" /></label></>}
    {error && <div className="error-strip" data-testid="set-password-error"><AlertCircle size={14} /> {error}</div>}
    {info && <button className="primary-button full" type="submit" disabled={busy || !pw} data-testid="set-password-submit">{busy ? "Saving…" : "Save and sign in"}</button>}
  </form></div>;
}
